import styled from 'styled-components';

import grid from '~/styles/grid';

export const Container = styled.div`
  display: flex;
  row-gap: ${grid.xxl};
  flex-direction: column;
  padding: 0 ${grid.sm};
`;
